import { FiPhoneCall } from "react-icons/fi";
import "./AnnouncementBar.css";

export default function AnnouncementBar() {
  return (
    <div className="announcement-bar">
      <div className="announcement-bar__track">
        <span>New batches opening in Peelamedu — limited slots</span>
        <span className="dot">•</span>
        <span>Strength · Functional · Weight Management · Personal Training</span>
        <span className="dot">•</span>
        <span>Coimbatore's engine room for results</span>
        <span className="dot">•</span>
      </div>
      <a href="tel:+919500886368" className="announcement-bar__call">
        <FiPhoneCall aria-hidden="true" /> +91 95008 86368
      </a>
    </div>
  );
}
